import { useEffect, useState } from 'react';

const TAILWIND_BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export const useResponsive = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

  useEffect(() => {
    let frameId: number | null = null;

    const handleResize = () => {
      if (frameId) cancelAnimationFrame(frameId);

      frameId = requestAnimationFrame(() => {
        const w = window.innerWidth;
        const h = window.innerHeight;

        // update only when values change
        setWidth((prev) => (prev !== w ? w : prev));
        setHeight((prev) => (prev !== h ? h : prev));

        setIsMobile((prev) => (prev !== w < 1200 ? w < 1200 : prev));
      });
    };

    // High-performance listener
    window.addEventListener('resize', handleResize, { passive: true });

    return () => {
      if (frameId) cancelAnimationFrame(frameId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    width,
    height,
    isMobile,

    // tailwind helpers
    isSm: width >= TAILWIND_BREAKPOINTS.sm,
    isMd: width >= TAILWIND_BREAKPOINTS.md,
    isLg: width >= TAILWIND_BREAKPOINTS.lg,
    isXl: width >= TAILWIND_BREAKPOINTS.xl,
    is2xl: width >= TAILWIND_BREAKPOINTS['2xl'],

    tailwind: TAILWIND_BREAKPOINTS,
  };
};
